import { Outlet } from 'react-router-dom'

export function PingsPage(): JSX.Element {
  return <Outlet />
}
